import { render, staticRenderFns } from "./Mainsoftware.vue?vue&type=template&id=dcb84876&scoped=true"
import script from "./Mainsoftware.vue?vue&type=script&lang=js"
export * from "./Mainsoftware.vue?vue&type=script&lang=js"
import style0 from "./Mainsoftware.vue?vue&type=style&index=0&id=dcb84876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb84876",
  null
  
)

export default component.exports